class Service {
}
export {
  Service
};
//# sourceMappingURL=service.js.map
